import { getSupabaseClient, type DdmSupabaseClient } from '../supabase';

// Server-side consent log (Spec M13.2): one row per decision, IP + user-agent
// captured by the log_consent RPC from request.headers. Fire-and-forget — a
// failure must never block the UI, since the ddm_consent cookie is the source of
// truth for gating GA/Meta.
export async function logConsent(
  analytics: boolean,
  marketing: boolean,
  client: DdmSupabaseClient = getSupabaseClient(),
): Promise<void> {
  const { error } = await client.rpc('log_consent', {
    p_analytics: analytics,
    p_marketing: marketing,
  });
  if (error) {
    console.warn('logConsent failed:', error.message);
  }
}
